function Appointment() {
    return (
        <section className="p-6 md:p-16 flex justify-center">

            <form className="w-full max-w-lg bg-white p-6 rounded-lg shadow">

                <h2 className="text-2xl font-bold mb-6 text-center">
                    Book Appointment
                </h2>

                <input className="w-full mb-4 p-2 border rounded" placeholder="Name" />
                <input className="w-full mb-4 p-2 border rounded" placeholder="Phone" />
                <input className="w-full mb-4 p-2 border rounded" placeholder="Email" />

                <select className="w-full mb-4 p-2 border rounded">
                    <option value="">-- Click to Select Service --</option>
                    <option>Massage</option>
                    <option>Physiotherapy</option>
                    <option>Yoga</option>
                    <option>Hydro Therapy</option>
                </select>

                <input type="date" className="w-full mb-4 p-2 border rounded" />

                <textarea className="w-full mb-4 p-2 border rounded" placeholder="Message"></textarea>

                <button className="w-full bg-green-600 text-white p-2 rounded">
                    Submit
                </button>

            </form>

        </section>
    );
}

export default Appointment;